import React from 'react';
import {useEmployeesQuery} from "@repo/services";

/**
 * Loads the employee directory and exposes helpers to resolve an employee record from a username (derived from their work email's local part) and to construct a placeholder `@agreserves.com` email from a username.
 *
 * @returns `{ getEmployeeFromUsername, getUserIdFromEmail, tempEmail }` helpers.
 */
export const useEmployees = () => {
    const { data: employees = [] } = useEmployeesQuery(null);

    const getUserIdFromEmail = (email: string) => {
        return email.split('@')[0];
    };

    const getEmployeeFromUsername = (userName: string) => {
        return employees?.find((employee) => getUserIdFromEmail(employee.workEmail) === userName);
    };

    const tempEmail = (userName: string) => `${userName}@agreserves.com`;

    return { getEmployeeFromUsername, getUserIdFromEmail, tempEmail }
}
